module.exports = __webpack_public_path__ + "static/img/产业升级.540125e3.png";